<template>
    <form @submit.prevent="submitPrevent" id="form" name="business_information_form" autocomplete="off"
          ref="business_information_form" class="content-inner formValidation">
        <div>
            <div class="row" id="business_information">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-12 col-12" v-if="!is_reviewing">
                            <div class="panel-sub-heading headingLarge">
                                <span class="h5 display-6 markedBottom bold">{{ lang('business_information') }}</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-12">
                            <div class="row">
                                <div class="col-12" ref="block_about_business">
                                    <np-input :no-wrapper="true" :id="'section'" :name="'section'" :type="'hidden'"
                                              model-value="BUSINESS_INFO"></np-input>
                                    <np-input
                                        :help-text="getTooltipText('quote_reg_number')"
                                        ref="reg_number"
                                        :id="`reg_number`"
                                        :name="`reg_number`"
                                        v-if="isRegNumberFirst && canQuoteShowRegNumber"
                                        :label="regNumberLabel"
                                        :minlength="getRegNoFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'min')"
                                        :maxlength="getRegNoFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max')"
                                        :rules=registerNumberRule
                                        :no-wrapper="false"
                                        :check_config="false"
                                        :required="isQuoteRegNumberRequired"
                                        @addon-click="searchByRegNumber"
                                        v-model="quote.reg_number">
                                        <template #addon>
                                        <span class="fa fa-search"></span>
                                        </template>
                                    </np-input>
                                    <np-select2
                                        :id="`ownership_entity_type`"
                                        :name="`ownership_entity_type`"
                                        ref="ownership_entity_type"
                                        :label="lang('business_type_question')"
                                        :placeholder="lang('business_type_question_select')"
                                        :required="true"
                                        :parameters="paramBusinessTypeSB"
                                        :no-wrapper="false"
                                        @input="toggleBusinessType"
                                        v-model="quote.ownership_entity_type">
                                    </np-select2>
                                    <np-input
                                        ref="legal_name"
                                        :id="`legal_name`"
                                        :name="`legal_name`"
                                        :label="lang('legal_name')"
                                        :maxlength="255"
                                        :help-text="getTooltipText('application_legal_name')"
                                        :rules="['alpha_company', 'required']"
                                        :no-wrapper="false"
                                        @addon-click="searchByLegalName"
                                        v-if="allowLegalNameSearch"
                                        v-model="quote.legal_name">
                                        <template #addon>
                                        <span class="fa fa-search"></span>
                                        </template>
                                    </np-input>
                                    <np-input
                                        ref="legal_name"
                                        :id="`legal_name`"
                                        :name="`legal_name`"
                                        :label="lang('legal_name')"
                                        :maxlength="255"
                                        :help-text="getTooltipText('application_legal_name')"
                                        :rules="['alpha_company','required']"
                                        :no-wrapper="false"
                                        :required="true"
                                        v-else
                                        v-model="quote.legal_name">
                                    </np-input>
                                    <np-input
                                            :help-text="getTooltipText('quote_reg_number')"
                                            ref="reg_number"
                                            :id="`reg_number`"
                                            :name="`reg_number`"
                                            :label="regNumberLabel"
                                            :minlength="getRegNoFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'min')"
                                            :maxlength="getRegNoFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max')"
                                            :rules=registerNumberRule
                                            :no-wrapper="false"
                                            :check_config="false"
                                            :required="isQuoteRegNumberRequired"
                                            @addon-click="searchByRegNumber"
                                            v-if="!isRegNumberFirst && canQuoteShowRegNumber"
                                            v-model="quote.reg_number">
                                        <template #addon>
                                        <span class="fa fa-search"></span>
                                        </template>
                                    </np-input>
                                </div>
                                <div class="col-12">
                                    <div class="row" ref="block_turnover">
                                        <div class="col-12">
                                            <div class="panel-sub-heading headingSmall"><span
                                                class="markedBottom">{{ lang('business_turnover') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-12">
                                            <np-input ref="annual_turnover"
                                                      :help-text="getTooltipText('application_annual_turnover_tooltip')"
                                                      :label="lang('annual_turnover')"
                                                      :id="'annual_turnover'"
                                                      :name="'annual_turnover'"
                                                      :rules="['turnover_numeric']"
                                                      :min="1"
                                                      :input-class="'turnover'"
                                                      :is-masked="true"
                                                      :required="true"
                                                      :addon-on-left="true"
                                                      v-model="quote.annual_turnover">
                                                <template #addon>
                                                <span>{{getCurrencyCodeSymbol()}}</span>
                                                </template>
                                            </np-input>
                                            <np-input
                                                    ref="'monthly_turnover'"
                                                    :id="'monthly_turnover'"
                                                    :name="'monthly_turnover'"
                                                    type="hidden"
                                                    :no-wrapper="true"
                                                    v-model="quote.monthly_turnover">
                                            </np-input>
                                            <np-input
                                                    :label="lang('monthly_card_turnover')"
                                                    :id="'monthly_card_turnover'"
                                                    :name="'monthly_card_turnover'"
                                                    ref="monthly_card_turnover"
                                                    :help-text="getTooltipText('application_estimated_monthly_card_turnover')"
                                                    :rules="['turnover_numeric', {'less_than_equal_field': 'monthly_turnover'}]"
                                                    :min="1"
                                                    :input-class="'turnover'"
                                                    :is-masked="true"
                                                    :required="true"
                                                    :addon-on-left="true"
                                                    v-model="quote.monthly_card_turnover">
                                                <template #addon>
                                                <span>{{getCurrencyCodeSymbol()}}</span>
                                                </template>
                                            </np-input>
                                            <np-input ref="avg_ticket_sales_amt"
                                                      :help-text="getTooltipText('application_business_average_transaction_value')"
                                                      :label="lang('field_business_average_transaction_value')"
                                                      :id="'avg_tran_value'"
                                                      :name="'avg_tran_value'"
                                                      :rules="['turnover_numeric', {'less_than_field': 'annual_turnover'}]"
                                                      :min="1"
                                                      :input-class="'turnover'"
                                                      :is-masked="true"
                                                      :required="true"
                                                      :addon-on-left="true"
                                                      v-model="quote.avg_tran_value">
                                                <template #addon>
                                                <span>{{getCurrencyCodeSymbol()}}</span>
                                                </template>
                                            </np-input>
                                        </div>

                                    </div>
                                    <div class="row" ref="block_transactions"  v-if="!quoteIsEcom  || isBlendedMid">
                                        <div class="col-12">
                                            <div class="panel-sub-heading headingSmall">
                                                <span class="markedBottom">{{ lang('transactions') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-12">
                                            <np-input
                                                :id="`sales_ftf_perc`"
                                                :name="`sales_ftf_perc`"
                                                :label="lang('sales_ftf_perc')"
                                                ref="sales_ftf_perc"
                                                :rules="['numeric', 'together_100_percent_group', {'percent_group': 'transactions'}]"
                                                :no-wrapper="false"
                                                :required="true"
                                                maxlength="3"
                                                v-model="quote.sales_ftf_perc">
                                                <template #addon>
                                                <span>%</span>
                                                </template>
                                            </np-input>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-12">
                                            <np-input
                                                :id="`sales_moto_perc`"
                                                :name="`sales_moto_perc`"
                                                :label="lang('sales_moto_perc')"
                                                :help-text="getTooltipText('application_sales_moto_perc')"
                                                ref="sales_moto_perc"
                                                :rules="['numeric', 'together_100_percent_group', {'percent_group': 'transactions'}]"
                                                :no-wrapper="false"
                                                :required="true"
                                                maxlength="3"
                                                v-model="quote.sales_moto_perc">
                                                <template #addon>
                                                <span>%</span>
                                                </template>
                                            </np-input>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-12" v-if="isBlendedMid">
                                            <np-input
                                                :label="lang('sales_internet_perc')"
                                                ref="sales_internet_perc"
                                                :id="'sales_internet_perc'"
                                                :name="'sales_internet_perc'"
                                                :rules="['numeric', 'together_100_percent_group', {'percent_group': 'transactions'}]"
                                                :no-wrapper="false"
                                                :required="true"
                                                maxlength="3"
                                                v-model="quote.sales_internet_perc">
                                                <template #addon>
                                                <span>%</span>
                                                </template>
                                            </np-input>
                                        </div>
                                    </div>
                                    <div class="row" ref="block_application_options">
                                        <div class="col-12">
                                            <div class="panel-sub-heading headingSmall">
                                                <span class="markedBottom">{{ lang('application_options') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <np-checkbox
                                                :label="lang('marketing_opt_in')"
                                                :id="'marketing_opt_in'"
                                                :name="'marketing_opt_in'"
                                                ref="marketing_opt_in"
                                                :description="lang('marketing_opt_in_tooltip')"
                                                :full-label="true"
                                                :check_config="true"
                                                :help-text="getTooltipText('marketing_opt_in')"
                                                :help-text-position="'label'"
                                                v-model="quote.marketing_opt_in">
                                            </np-checkbox>
                                        </div>
                                        <div class="col-12">
                                            <np-checkbox
                                                    :label="lang('marketing_opt_out')"
                                                    :id="'marketing_opt_out'"
                                                    :name="'marketing_opt_out'"
                                                    ref="marketing_opt_out"
                                                    :description="lang('marketing_opt_out_tooltip')"
                                                    :full-label="true"
                                                    :invert-check="true"
                                                    :check_config="true"
                                                    v-model="quote.marketing_opt_in">
                                            </np-checkbox>
                                        </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-12">
                            <div class="row">
                                <div class="col-12" ref="block_business_detail">
                                    <np-select2
                                        ref="business_sector"
                                        :id="'business_sector'"
                                        :name="'business_sector'"
                                        :label="lang('business_sector_question')"
                                        :placeholder="lang('business_sector')"
                                        :parameters="paramBusinessSectorsSB"
                                        :required="true"
                                        v-model="quote.business_sector">
                                    </np-select2>
                                    <np-select2
                                        ref="mcc_iso"
                                        :id="'mcc_iso'"
                                        :name="'mcc_iso'"
                                        :label="lang('mcc_iso_question')"
                                        :placeholder="lang('category')"
                                        :parameters="mccIsoParam"
                                        :required="true"
                                        v-model="quote.mcc_iso">
                                    </np-select2>
                                    <np-radios
                                            ref="payment_method"
                                            :id="'payment_method'"
                                            :name="'payment_method'"
                                            :label="lang('card_acceptance_method')"
                                            :mode="'co-join'"
                                            @input="alertChangePaymentMethod"
                                            :options="parameters.CARD_ACCEPTANCE_METHODS"
                                            v-model="quote.payment_method">
                                    </np-radios>
                                    <np-radios
                                        ref="new_to_payments"
                                        :id="'new_to_card_payments'"
                                        :name="'new_to_card_payments'"
                                        :mode="'co-join'"
                                        :required="true"
                                        :label="lang('new_to_card_payments')"
                                        :options="parameters.YES_NO_OPTIONS"
                                        v-model="quote.new_to_card_payments">
                                    </np-radios>
                                    <np-radios
                                        ref="previous_acquirer"
                                        :id="'previous_acquirer'"
                                        :name="'previous_acquirer'"
                                        :mode="'co-join'"
                                        :required="true"
                                        :label="lang('previous_acquirer')"
                                        :options="reversedYesNoOption"
                                        v-model="quote.new_to_card_payments">
                                    </np-radios>
                                    <np-radios
                                               v-if="is_girocard_only_active"
                                               ref="girocard_only"
                                               :id="'girocard_only'"
                                               :name="'girocard_only'"
                                               :label="lang('girocard_only')"
                                               :mode="'co-join'"
                                               :options="parameters.YES_NO_OPTIONS"
                                               v-model="quote.girocard_only">
                                    </np-radios>
                                </div>
                                <div class="col-12" ref="block_personal_information">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="panel-sub-heading headingSmall"><span
                                                class="markedBottom">{{ lang('business_contact') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-12">
                                            <div class="row">
                                                <div class="col-lg-7 col-md-8 col-sm-12">
                                                    <np-radios
                                                        :name="'contact_title'"
                                                        :id="'contact_title'"
                                                        :label="lang('field_title')"
                                                        :options="primeTitles"
                                                        :required="true"
                                                        :mode="'separate'"
                                                        ref="owner_title"
                                                        v-model="quote.contact_title">
                                                    </np-radios>
                                                </div>
                                                <div class="col-lg-5 col-md-4 col-sm-12">
                                                    <np-select2 v-if="quote.contact_title === 'other' && !!otherTitles
                                                         && otherTitles.length > 0"
                                                                :name="'other_contact_title'"
                                                                :id="'other_contact_title'"
                                                                :placeholder="lang('field_title')"
                                                                :parameters="otherTitles"
                                                                :label="''"
                                                                :rules="['required']"
                                                                :required="true"
                                                                ref="owner_title"
                                                                v-model="quote.other_contact_title">
                                                    </np-select2>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-12">
                                                    <np-input
                                                        :name="'contact_first_name'"
                                                        :id="'contact_first_name'"
                                                        :label="lang('field_first_name')"
                                                        :no-wrapper="false"
                                                        :rules="['alpha_name','required']"
                                                        :maxlength="getFirstNameMaxLengthByIso3('max')"
                                                        :required="true"
                                                        ref="owner_first_name"
                                                        v-model="quote.contact_first_name">
                                                    </np-input>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-12">
                                                    <np-input
                                                        :name="'contact_second_name'"
                                                        :id="'contact_second_name'"
                                                        :label="lang('field_middle_name')"
                                                        :no-wrapper="false"
                                                        :rules="['alpha_name']"
                                                        :maxlength="25"
                                                        :required="false"
                                                        ref="owner_second_name"
                                                        v-model="quote.contact_second_name">
                                                    </np-input>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-12">
                                                    <np-input
                                                        :name="'contact_last_name'"
                                                        :id="'contact_last_name'"
                                                        :label="lang('field_last_name')"
                                                        :no-wrapper="false"
                                                        :rules="['alpha_name', 'required']"
                                                        :maxlength="25"
                                                        :required="true"
                                                        ref="owner_surname"
                                                        v-model="quote.contact_last_name">
                                                    </np-input>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-12">
                                            <np-input
                                                :name="'contact_email_address'"
                                                :id="'contact_email_address'"
                                                :label="lang('field_email')"
                                                :no-wrapper="false"
                                                :rules="['valid_email', 'required']"
                                                :maxlength="100"
                                                ref="owner_email"
                                                v-model="quote.email_address">
                                            </np-input>
                                            <div class="row compactInputFormat"  ref="owner_phone">
                                                <div class="col-12 col-md-12">
                                                    <label>{{ lang('phone') }}</label>
                                                </div>
                                              <div class="input-group">
                                                <div class="col-5">
                                                    <np-select2
                                                        :name="'contact_phone_code'"
                                                        :id="'contact_phone_code'"
                                                        :placeholder="lang('phone_code')"
                                                        :no-wrapper="true"
                                                        :mode="`phone`"
                                                        :required="true"
                                                        ref="owner_phone_code"
                                                        :parameters="parameters.PHONE_CODES"
                                                        v-model="quote.ent_telephone_code">
                                                    </np-select2>
                                                </div>
                                                <div class="col-7">
                                                    <np-phone ref="owner_phone_no"
                                                              :name="'contact_phone_no'"
                                                              :id="'contact_phone_no'"
                                                              :no-wrapper="true"
                                                              :label="lang('phone_number')"
                                                              :rules="['numeric', 'required', 'phone_no_leading_zero']"
                                                              :maxlength=" getPhoneNoMaxLengthByIso3( getIso3FromPhoneCode( quote.ent_telephone_code ) ) "
                                                              :minlength=" getPhoneNoMinLengthByIso3( getIso3FromPhoneCode( quote.ent_telephone_code ) ) "
                                                              :required="true"
                                                              :phone-code="quote.ent_telephone_code"
                                                              v-model="quote.telephone_number">
                                                    </np-phone>
                                                </div>
                                              </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-12">
                                            <np-radios
                                                ref="multi_signer"
                                                :id="'multi_signer'"
                                                :name="'multi_signer'"
                                                :label="lang('principals_sign_documents')"
                                                :mode="'co-join'"
                                                :required="true"
                                                :options="parameters.MULTI_SIGNER"
                                                v-model="quote.multi_signer">
                                            </np-radios>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="!is_reviewing">
<!--                        <div class="col-lg-6 col-md-6 col-12" v-if="!!isPublicUser">-->
<!--                            <np-radios-->
<!--                                ref="opt_with"-->
<!--                                :id="'opt_with'"-->
<!--                                :name="'opt_with'"-->
<!--                                :label="lang('send_onetime_password_to')"-->
<!--                                :mode="'co-join'"-->
<!--                                :check_config="false"-->
<!--                                :required="true"-->
<!--                                :options="parameters.OTP_OPTIONS"-->
<!--                                v-model="quote.opt_with">-->
<!--                            </np-radios>-->
<!--                        </div>-->
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall"><span
                                class="markedBottom">{{ lang('gdpr') }}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-12">
                            <p>
                                {{lang('consent_to_gdpr')}}
                                <span><a @click="mailEUDataProtectionOffice" href="mailto:EUDataProtectionOffice@elavon.com">EUDataProtectionOffice@elavon.com.</a></span>
<!--                                <span style="cursor: pointer;" @click="setModalData">{{lang('view_privacy_policy')}}</span>-->
                                {{lang('view')}}
                                <span><a style="display: inline; cursor: pointer;" target="_blank" :href="privacy_policy_link">{{lang('privacy_policy')}}</a>.</span>
                            </p>
                        </div>
                    </div>
                    <div class="row mt-4" style="border-top: 1px solid #b2c6d0"  v-if="is_reviewing && !isLockedQuote" >
                        <div class="col-12">
                            <div class="my-3">
                                <a class="btn btn-default" @click="updateQuote"> {{lang('save')}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <np-pdf-modal url="/application/viewgdprdocument/" :title="lang('elavon_privacy_policy')"  id="elavon-gdpr-pdf"></np-pdf-modal>

        <np-company-search ref="company-search"
                           :company-name="quote.legal_name"
                           :registration-number="quote.reg_number"
                           :country_code="this.baseCountryCode"
                           :country=" getIso3FromCountryCode( this.baseCountryCode ) "
                           :reference="merchantReference"
                           :search_bisnode_data="isBisNodeSearch"
                           :show_reg_num_options="isGermanAlliance"
                           @data="processCompanySearchData($event, quote)">
        </np-company-search>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0" v-if="!is_reviewing">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-default" :disabled="quote.gdpr_agreement != '1' || disableContinueBtn" @click="doContinue"> {{lang('continue')}} {{!!disableContinueBtn ? '...' : ''}}</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal,
        NPPdfModal,
        NPPhone,
        NPPostcodeSearch,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton,
        NPTextArea,
        NPVat,
        NPSelect2Multi
    } from "netpify/components";
    import EcomPaymentMethod from "../../../components/ecom-payment-method.vue"

    import {mapActions} from "pinia";
    import * as types from "../../../stores/constants";
    import useApplicationStore from "../../../stores/application_module";
    import useModuleStore from "../../../stores";
    //import EventBus from "../../../utils/event_bus";
    //import {Contact} from "../../../entities";

    export default {
        name: "businessInformation",
        mixins:[utilMixin, applicationMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-pdf-modal': NPPdfModal,
            'np-select2-multi': NPSelect2Multi,
            'ecom-payment-method': EcomPaymentMethod
        },
        props: {
          is_reviewing: {
              default: false,
              type: Boolean,
          }
        },
        data() {
            return {
                status: '',
                page_label: 'tell_us_bit_about_your_business',
                page_config_template: 'SelfBusinessCriteria',
                financial_values: [
                    'sales_ftf_perc',
                    'sales_moto_perc',
                    'sales_internet_perc',
                ],
                currentUrl: '',
                avoidRouteLeave: false,
                old_payment_method: '',
                privacy_policy_link: '',
            }
        },
        metaInfo () {
            return {
                title: this.lang('business_information')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.isSignerUser && (to.fullPath.includes('/application/add') || to.fullPath.includes('/application/edit') ||
                    to.fullPath.includes('/quote/add') || to.fullPath.includes('/quote/edit'))) {
                    let application_reference = null;
                    if (!!vm.merchant_user_access && vm.merchant_user_access.hasOwnProperty('application')
                        && vm.merchant_user_access.application.length > 0) {
                        if (vm.merchant_user_access.application.length > 1) {
                            const application = vm.merchant_user_access.application[vm.merchant_user_access.application.length - 1];
                            application_reference = application.application_reference;
                        } else {
                            application_reference = vm.merchant_user_access.application[0].application_reference;
                        }
                    }
                    if (!!application_reference) {
                        vm.$router.push({ path: `/application/view/${application_reference}/business_details/`})
                    } else {
                        vm.$router.push({path: from.fullPath})
                    }
                }
                    vm.setAppPageTitle(vm.page_label);

              if(vm.quote.hasOwnProperty('contact_title') && vm.quote.contact_title !== 'other' ) {
                vm.setOtherTitle(vm.quote);
              }
              //prevent user manual url change might break when we have multiple quote and applications
              // if (!!vm.merchant_user_access && vm.merchant_user_access.hasOwnProperty('application')
              //     && vm.merchant_user_access.application.length > 0) {
              //   let quote = vm.merchant_user_access.application.find(app => {
              //     return app.quote_external_id === vm.$route.params.quote_id
              //   })

                //re mask the values when returning to this page. Never happens on first load
                if(!!vm.quote.annual_turnover){
                    setTimeout(function () {
                    vm.maskTurnoverFields(vm.quote)

                    }, 500)
                }
                // if (!!quote)
                // vm.$router.push({path: `/quote/view/${vm.$route.params.quote_id}/business/`})
              // }
            });
        },
        beforeRouteLeave(to, from, next) {
            let vm = this;

            if (!this.checkDestinationRoute(to, from)) { //if user is going backwards, don't validate
                next()
                return;
            }

            if (this.isLockedQuote) {
                next(true);
            } else {
                if (!this.inQuoteViewMode) {  //TODO additional check don't update if I'm going to home page??
                    // if business information page,
                    //console.log('quote', this.quote)
                    if (!this.isInitiatedQuote && !this.isConvertedQuote) {// initiate  if it hasn't been initiated or converted
                        this.initiateQuote();
                    } else {
                        this.updateQuote(() => {
                            next()
                        })
                    }
                } else {
                    next(true)
                }
            }
        },
        created() {
            this.pageConfig = this.page_config[this.page_config_template];
            this.privacy_policy_link = vue_data.hasOwnProperty('parameters') && vue_data.parameters.hasOwnProperty('BRANDING') ? vue_data.parameters.BRANDING.privacy_policy_link : 'https://www.elavon.co.uk/privacy-policy.html';
            $(document).ready(function(){
                $('.turnover').mask('000,000,000,000,000,000,000,000,000', {reverse: true});
            });
        },
        mounted() {
            let vm = this;

            // EventBus.$on("data", (data) => {
            //     vm.setQuoteAddressFromSearchAddress(data);
            // });

            if (vm.shallLoadCaptcha()) {
                const plugin = document.createElement("script");
                plugin.setAttribute(
                    "src",
                    "https://www.google.com/recaptcha/api.js?render=" + vm.siteKey
                );
                plugin.async = true;
                document.head.appendChild(plugin);
            }
            const moduleStore = useModuleStore();
            moduleStore.commit(types.TOGGLE_LOADING, true);
            setTimeout(function () {
              vm.pageConfig = vm.page_config[vm.page_config_template];
                vm.runPageConfig(vm.page_config[vm.page_config_template]);
                moduleStore.commit(types.TOGGLE_LOADING, false);
                $("#form").formValidator({
                    // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: '',
                });
            }, 1000);

            //gives enough time for quote data to populate and page config to execute
            setTimeout(function (){
                if(vm.hasTenantAppDefaults) {
                    vm.setApplicationDefaults(vm.quote, 'BUSINESS', vm.parameters.TENANT_APP_DEFAULTS_PARAM)
                    vm.setApplicationDefaults(vm.quote, 'MAIN_OUTLET', vm.parameters.TENANT_APP_DEFAULTS_PARAM)
                }
                vm.setOtherTitle(vm.quote);

            }, 3000)

        },
        computed: {
            is_girocard_only_active: function (){
                return (this.allianceCountry === '276')
            },
            isCharity: function () {
                if(!!this.quote && !!this.quote.ownership_entity_type) {
                    return this.quote.ownership_entity_type === this.business_types.TRUST || this.quote.ownership_entity_type === this.business_types.CHARITY;
                }

                return false;
            },
            mccIsoParam: function () {
                let vm = this;
                if (!!vm.quote && !!vm.quote.business_sector && !!vm.paramBusinessMCCSB) {
                    return vm.paramBusinessMCCSB.filter(obj => {
                        return obj.ces_description_en === vm.quote.business_sector
                    });
                }

                return vm.paramBusinessMCCSB;
            },
            financialTotal: function () {
                let vm = this;
                let reducer = (acc, curr) => {
                    let val = parseInt(vm.quote[curr]);
                    return acc + (!isNaN(val) ? val : 0);
                };
                return vm.financial_values.reduce(reducer, 0);
            },
            siteKey: function () {
                return "6Lf7UjkbAAAAAF9Uu9H1xLqcXeQ9mLicM5Cwe3BN";
            },
            can_process_german_ecom_payment: function () {
                return (this.quote.sales_internet_perc > 0 && this.allianceCountry === '276')
            },
        },
        methods: {
            ...mapActions(useApplicationStore, [types.SET_MATCHED_PACKAGES, types.SET_EQUIPMENT_OFFER,
              types.SET_ONLINE_OFFER,
              types.SET_ACQUIRING_OFFER]),
            pageHasData: function (){
                return this.formHasValues($('#form'))
            },
            setModalData: function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $('#elavon-gdpr-pdf').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            },
            mailEUDataProtectionOffice: function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                window.location.href = "mailto:EUDataProtectionOffice@elavon.com";
                objCommon.generalPreloader.hide_pl();
            },
            setQuoteBusinessSector: function () {
                if (!!this.parameters) {
                    let mcc = this.paramBusinessMCCSB.find(obj => obj.id === this.quote.mcc_iso);

                    if (!!mcc) {
                        this.quote.business_sector = mcc.ces_description_en;
                    }
                }
            },
            setTransactionsBasedOnPaymentMethod: function ($event) {
                let vm = this;

                if (vm.isBlendedMid) {
                    if (vm.hasTenantAppDefaults) {
                        vm.setApplicationDefaults(vm.quote, 'BUSINESS', vm.parameters.TENANT_APP_DEFAULTS_PARAM)
                        vm.setApplicationDefaults(vm.quote, 'MAIN_OUTLET', vm.parameters.TENANT_APP_DEFAULTS_PARAM)
                    }
                } else {
                    if ($event === this.payment_method.PAYMENT_METHOD_ECOM_ONLY) {
                        this.quote.sales_ftf_perc = "0";
                        this.quote.sales_moto_perc = "0";
                        this.quote.sales_internet_perc = "100";
                    } else {
                        if (vm.hasTenantAppDefaults) {
                            //empty ecom stuff set internet to 0
                            this.quote.sales_ftf_perc = this.quote.sales_ftf_perc !== '' && this.quote.sales_ftf_perc !== '0' ? this.quote.sales_ftf_perc : '';
                            this.quote.sales_moto_perc = this.quote.sales_moto_perc !== '' && this.quote.sales_moto_perc !== '0' ? this.quote.sales_moto_perc : '';
                            this.quote.sales_internet_perc = '0';
                            vm.setApplicationDefaults(vm.quote, 'BUSINESS', vm.parameters.TENANT_APP_DEFAULTS_PARAM)
                            vm.setApplicationDefaults(vm.quote, 'MAIN_OUTLET', vm.parameters.TENANT_APP_DEFAULTS_PARAM)
                        }
                    }
                }
            },
            setVatOptions: function ($event) {
                 if($event === '1'){
                    this.quote.vat_applied_flag = '';
                }
            },
            setOtherVatTypes: function ($event) {
                // if vat options is vat pending unset every sub option
                if ($event === 'VAT_PENDING') {
                    this.quote.other_tax_decision = '';
                    this.quote.other_tax_id = '';
                }
            },
            searchByLegalName() {
                const component = this.$refs['company-search'];
                component.show();
                component.searchByCompanyName();
            },
            doContinue: function (){
                let vm = this;
                let path_to = this.quote_root_path + 'business/products/';

                if (this.isLockedQuote || this.inQuoteViewMode) {
                    // this.nextPage();
                    this.$router.push({path: this.quote_root_path + 'business/products/'})
                } else if (!this.isInitiatedQuote && !this.isConvertedQuote) {
                    this.initiateQuote();
                } else if(this.isInitiatedQuote && !this.isConvertedQuote && this.quote.multi_signer === this.quote_multi_signer){
                    this.updateQuote();
                }
                //if merchant is initated quote is on the application/add/business route and  changes multisigner to 1, update and force href to quote like in initateQuote
                else if(this.isInitiatedQuote && this.quote_root_path.includes('application/add') && this.quote.multi_signer !== this.quote_multi_signer){
                    this.updateQuote( (response) => {
                        location.href = '/quote/edit/' + response.data.quote.quote_external_id + '/business/products/';
                    });
                }
                else {
                    vm.$router.push({path: path_to})
                }
            },
            checkQuoteHasOffersSelected: function (){
              return (this.quote.hasOwnProperty('equipment_offer')   && this.objectIsNotEmpty(this.quote.equipment_offer)) ||
                  (this.quote.hasOwnProperty('online_offer') && this.objectIsNotEmpty(this.quote.online_offer))
            },
            toggleGdprAgreement: function () {
                this.quote['has_merchant_confirmed_gdpr'] = this.quote.gdpr_agreement;
            },
            toggleBusinessType: function () {
                if (this.merchant) {
                    this.merchant['ownership_entity_type'] = this.quote.ownership_entity_type;
                }
            },
            alertChangePaymentMethod: function ($event) {
                //show message that the selected equipments and services will be lost.
                let vm = this;
                if (this.checkQuoteHasOffersSelected()) {
                    //show  alert if they click yes, carry on witrh change else set old value.
                    this.$swal({
                        title: this.lang('are_you_sure'),
                        text: this.lang('once_changed_you_will_lose_the_previously_saved_equipments'),
                        icon: "warning",
                        confirmButtonColor: '#e64942',
                        showCancelButton: true,
                        confirmButtonText: this.lang('ok'),
                        cancelButtonText:this.lang('cancel'),
                        customClass: {
                            cancelButton: 'order-1',
                            confirmButton: 'order-2',
                        },
                        dangerMode: true,
                    }).then((willDelete) => {
                        if (willDelete.value) {
                            //unset package id as well as all equipment and online offer related blocks
                            this.quote['equipment_offer'] = {};
                            this.quote['online_offer'] = {};
                            this.quote['agreement_length'] = '';
                            this.quote['purchase_agreement_length'] = '';
                            this.quote['package_external_id'] = '';
                            //unset states as well
                            vm.unsetQuotePackageStates();
                            vm.$emit('dump_quote_offer_details', vm.quote)
                            vm.setTransactionsBasedOnPaymentMethod($event)
                        } else {
                            //revert to the previous value.
                            this.quote.payment_method = this.old_payment_method
                            vm.$emit('revert-payment_method', this.quote.payment_method)
                        }
                    });
                } else {
                    vm.setTransactionsBasedOnPaymentMethod($event)
                    //if no offers are selected but there is a package id dump and matched packages because they won't match the payment method anymore
                    if (this.quote.hasOwnProperty('package_external_id') && this.quote.package_external_id !== '') {
                        this.quote['package_external_id'] = '';
                        //unset states as well
                        vm.unsetQuotePackageStates();
                        vm.$emit('dump_quote_offer_details', vm.quote)
                    }
                }
            },
            unsetQuotePackageStates: function () {
                let vm = this;
                vm[types.SET_MATCHED_PACKAGES]({});
                vm[types.SET_EQUIPMENT_OFFER]({});
                vm[types.SET_ONLINE_OFFER]({});
                vm[types.SET_ACQUIRING_OFFER]({});
            },
            maskTurnoverFields: function (quote, unmask = false){
                let turnover_fields = ['annual_turnover', 'monthly_card_turnover', 'avg_tran_value'];
                let vm = this;
                turnover_fields.forEach(obj => {
                    if (quote.hasOwnProperty(obj) && !!quote[obj]) {
                        if (!!unmask) {
                            quote[obj] = vm.cleanTurnoverFields(quote[obj])
                        } else {
                            let $turnover = $('.turnover');
                            if (!!$turnover && !!$turnover.data('mask')) {
                                quote[obj] = $turnover.masked(quote[obj])
                            }
                        }
                    }
                })
            },
            cleanTurnoverFields: function (value) {
                return value.replace(/,/g, '');
            },
            validateBusinessInfo: function () {
                let form_is_valid = this.validateForm('#form');
                let form = this.getFormData($('#form')), section = form.section;
                this.quote.section = section;

                    let turnover_fields = ['annual_turnover', 'monthly_card_turnover', 'avg_tran_value'];
                    let turnover_errors = [];
                    turnover_fields.forEach(obj => {
                        if (this.quote.hasOwnProperty(obj) && !!this.quote[obj]) {
                            if (this.countDecimals(this.quote[obj]) > 0) { //don't let any decimals.
                                turnover_errors.push(obj)
                            }
                        }
                    })

                    if (turnover_errors.length > 0) {
                        this.notifyError(this.lang('validation_error'), this.lang('validation_integer'))
                        // this.notifyError(this.lang('validation_error'), this.lang('validation_turnover_fields_two_decimals'))
                        return false;
                    }

                return form_is_valid;
            },
            initiateQuote: function () {
                let vm = this;
                if(!!this.disableContinueBtn){
                    return;
                }
                if (vm.validateBusinessInfo()) {
                    this.disableContinueBtn = true;
                    if (vm.shallLoadCaptcha()) {
                        if (!grecaptcha) {
                            return;
                        }
                        grecaptcha.ready(function() {
                            grecaptcha.execute(vm.siteKey, {action: 'submit'}).then(recaptcha_token => {
                                vm.quote.recaptcha_token = recaptcha_token;
                                vm.sendInitiateQuote();  //initiate quote request
                            });
                        });
                    }
                    else {
                        vm.sendInitiateQuote();  //initiate quote request
                    }
                }

              this.revertContinueButton();
            },
            sendInitiateQuote: function () {
                let vm = this;

                this.quote.blended_mids_off = !this.isBlendedMid; //if isblendedmid = true then blended mids off = false
                //initiate quote
                vm[types.INITIATE_QUOTE](vm.quote).then(response => {
                    if (response.data.result === 'SUCCESS') {
                        vm.notifySuccess(vm.lang('quote_initiated_successfully'));

                        if (response.data.quote && response.data.quote.hasOwnProperty('multi_signer') && response.data.quote.multi_signer === this.quote_multi_signer) {
                            vm.alertMultiSigner();
                        }
                        else {
                            location.href = '/quote/edit/' + response.data.quote.quote_external_id + '/business/products/';
                        }
                    } else if (response.data.result === 'ERROR' && response.data.error) {
                        let error_data = response.data.error;

                        if (error_data.code && error_data.code === '12-49-021') {
                            // Popup message: 'E_12-49-021' => 'reCAPTCHA score too low',
                            vm.alertUnableSelfBoarding();
                        }
                    } else {
                        vm.disableContinueBtn = false;
                    }
                }).catch(error => {
                    //console.log(error)
                });
            },
            updateQuote(callback = null){
                let vm = this;
                if (!!this.disableContinueBtn) { //avoid double click
                    return;
                }
                if (vm.validateBusinessInfo()) {
                    this.disableContinueBtn = true;
                    this.quote.blended_mids_off = !this.isBlendedMid; //if isblendedmid = true then blended mids off = false
                    let has_merchant_data = !!vm.merchant && Object.keys(vm.merchant).length > 0;

                    let payload_data = this.jsonCopy(vm.quote);
                    if (!!payload_data.equipment_offer) {
                        payload_data.equipment_offer = this.formatEquipmentOfferForWAF(payload_data.equipment_offer);
                    }
                    if (!!payload_data.acquiring_offer) {
                        payload_data.acquiring_offer = this.formatAcquiringOfferForWAF(payload_data.acquiring_offer);
                    }
                    //update quote
                    vm[types.UPDATE_QUOTE](payload_data).then(response => {
                        if (response.data.result === 'SUCCESS') {
                            vm.notifySuccess(vm.lang('business_info_updated_successfully'));
                            if (vm.is_reviewing) {
                              vm.$emit('close_review_section');
                            }

                            //sync application data to quote if needed
                            if (has_merchant_data && vm.quote) {
                                let application_to_quote_intersect_fields = {
                                    'reg_number': 'reg_number',
                                    'tax_id': 'tax_id',
                                };
                                Object.keys(application_to_quote_intersect_fields).forEach(key => {
                                    if (!!vm.quote[key]) {
                                        vm.merchant[application_to_quote_intersect_fields[key]] = vm.quote[key];
                                    }
                                });
                                vm.setMerchantRegistrationAddressFromQuote();
                            }

                            if (response.data.quote && response.data.quote.hasOwnProperty('multi_signer')
                                && response.data.quote.multi_signer === this.quote_multi_signer) {
                                vm.alertMultiSigner();
                            }
                            else {
                                if (!!callback) { //call back is the next function in nav guard
                                    callback(response);
                                }
                            }
                        }else{
                            this.disableContinueBtn = false;
                        }
                    }).catch(error => {
                        //console.log(error)
                    })
                }

                this.revertContinueButton();
            },
            shallLoadCaptcha: function () {
                //check if need reCaptcha
                let vm = this;
                return (vm.user && vm.user.hasOwnProperty('is_public_user') && (vm.user.is_public_user === '1')
                    && vue_data && !(vue_data.quote_external_id));
            },
            alertMultiSigner: function () {
                let vm = this;
                vm.$swal({
                    title: this.lang('multi_signer'),
                    text: this.lang('unfortunately_you_are_not_eligible_for_self_boarding'),
                    icon: "warning",
                    button: this.lang('ok'),
                });
            },
            formatSupportPhone: function (){
                let formatted_support_phone = '0000 000 0000';
                let alliance = vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;

                let partner = null;
                if (vue_data && vue_data.hasOwnProperty('user') && vue_data.user.hasOwnProperty('partner')) {
                    partner = vue_data.user.partner;
                }

                if (partner && partner.hasOwnProperty('support_phone') && !!(partner.support_phone)) {
                    let phone_no = partner.support_phone;
                    if (phone_no.length >= 7) {
                        formatted_support_phone = phone_no.substring(0, 4) + ' ' + phone_no.substring(4, 7)
                            + ' ' + phone_no.substring(7, phone_no.length);
                    }
                    else {
                        formatted_support_phone = phone_no;
                    }

                    if (partner.hasOwnProperty('support_phone_code') && !!(partner.support_phone_code)) {
                        let phone_code = !!partner.support_phone_code ? this.formatPhoneCode(partner.support_phone_code) : '';
                        formatted_support_phone = phone_code + ' ' + formatted_support_phone;
                    }
                }
                else if (alliance && alliance.hasOwnProperty('support_phone') && !!(alliance.support_phone)) {

                    let phone_no = alliance.support_phone;
                    if (phone_no.length >= 7) {
                        formatted_support_phone = phone_no.substring(0, 4) + ' ' + phone_no.substring(4, 7)
                            + ' ' + phone_no.substring(7, phone_no.length);
                    }
                    else {
                        formatted_support_phone = phone_no;
                    }

                    if (alliance.hasOwnProperty('support_phone_code') && !!(alliance.support_phone_code)) {
                        let phone_code = !!alliance.support_phone_code ? this.formatPhoneCode(alliance.support_phone_code) : '';
                        formatted_support_phone = phone_code + ' ' + formatted_support_phone;
                    }
                }
                return formatted_support_phone;
            },
            alertUnableSelfBoarding: function () {
                let vm = this;
                let message = document.createElement("span");
                message.innerHTML = '<p class="text-center">'+ this.lang('unable_to_progress_with_application_via_self_boarding')
                    + '<br><br>' + vm.formatSupportPhone() +'</p>';
                vm.$swal({
                    content: message,
                    icon: "warning",
                    button: this.lang('ok'),
                });
            },
            setMerchantRegistrationAddressFromQuote: function () {
                let vm = this;
                if (!(vm.quote) || !(vm.quote.registration_address)) {
                    return;
                }
                let mapAddressFields = {
                    'house_number': 'house_number',
                    'house_name': 'house_name',
                    'street_line_1': 'street_line_1',
                    'street_line_2': 'street_line_2',
                    'zip_code': 'zip_code',
                    'city': 'city',
                    'county_code': 'county_code',
                    'country_code': 'country_code',
                };
                //if quote registration address is not qualified, we don't update application registration address
                let quote_country_code = !!(vm.quote.registration_address.country_code);
                let quote_city = !!(vm.quote.registration_address.city);
                let quote_zip_code = !!(vm.quote.registration_address.zip_code);
                if (quote_country_code && quote_city && quote_zip_code) {
                    Object.entries(mapAddressFields).forEach( ([quote_key, merchant_key]) => {
                        if (vm.quote.registration_address[quote_key] && !!vm.merchant.registration_address) {
                            vm.merchant.registration_address[merchant_key] = vm.quote.registration_address[quote_key];
                        }
                    });
                }
            },
            updateEcomPaymentMethod: function (method_group_type, event) {
                let method_list = [...event];

                if (this.can_process_german_ecom_payment) {
                    let method_group_data = this.quote.ecom_payment_methods[method_group_type];

                    if (method_list.includes('paypal_MID') && !method_list.includes('paypal_address')) {
                        method_list.push('paypal_address');
                    } else {
                        method_list = method_list.filter(method => method !== 'paypal_address');
                    }
                    method_group_data = method_group_data.filter(method => method_list.includes(Object.keys(method)[0]));
                    for (let i = 0; i < method_list.length; i++) {
                        let methodExists = method_group_data.some(method => Object.keys(method)[0] === method_list[i]);
                        if (!methodExists) {
                            let newMethod = { [method_list[i]]: '' };
                            method_group_data.push(newMethod);
                        }
                    }

                    let ecom_payment_methods = { ...this.quote.ecom_payment_methods, [method_group_type]: method_group_data };
                    console.log(ecom_payment_methods)
                    this.quote['ecom_payment_methods'] = ecom_payment_methods;
                }
            },
        },
        watch: {
            'quote.payment_method': {
                immediate: true,
                handler: function (val, oldVal) {
                    if(!!val && typeof oldVal == 'undefined'){ //do this on the first load.
                        this.setTransactionsBasedOnPaymentMethod(val)
                    }

                    if (!!oldVal) { //if there is an old value save it in old_payment_method
                        this.old_payment_method = oldVal
                    }
                }
            },
            //because business sector is not set on opportunity, once we map the opportunity to
            //quote and then get parameters, set the quote business sector.
            'quote.mcc_iso': {
                immediate: true,
                handler: function (val, oldVal) {
                    if (val !== '' && typeof val !== 'undefined'){
                      // this.quote.business_sector ='';
                        this.setQuoteBusinessSector()
                    }
                }
            },
            'quote.annual_turnover': {
                handler: function (val, oldVal) {
                    let vm = this;

                    //mask inputs
                    //fire once when quote has been retrieved. this reduces the delay in showing the masked value.
                    if (!!val && typeof oldVal === 'undefined') {
                        setTimeout(function () {
                            vm.maskTurnoverFields(vm.quote)
                        }, 500)
                    }

                    //remove commas
                    val = val !== '' && val !== undefined ? val.replace(/,/g, '') : 0
                    this.quote['monthly_turnover'] = Math.floor(val/12);
                },
                immediate: true,
            },
            financialTotal: {
                immediate: true,
                handler: function (val) {
                    if (val === 100) {
                        let vm = this;
                        vm.financial_values.forEach(function (value, index) {
                            if (isNaN(parseInt(vm.quote[value]))) {
                                vm.quote[value] = 0;

                            }
                        })
                    }
                }
            },
        }
    }
</script>

<style scoped>
body#portal #marketing-help {
  line-height: 18px;
}
</style>
